import React from 'react';

import AboutMeLewaStrona from '../AboutMeLewaStrona';
import ObrazekBezAni from '../Nie-Animowane/ObrazekBezAni';

const AboutUpSection = (props) => {
    return (
        <div>
            <div className='flex justify-between'>
                <div className='absolute top-1/2 left-1/5 text-white z-10'>
                    <AboutMeLewaStrona czyZanimowane={props.czyZanimowane} 
                    inView={props.inView} tytul={props.tytul} button={false} text={props.text}/>
                </div>
                <ObrazekBezAni cover={true} src={props.obrazek} />
            </div>
        </div>
    );
}

export default AboutUpSection;
